import { ActionReducer, ActionReducerMap } from '@ngrx/store';
import * as fromAuth from '../auth/store/auth.reducer';
import * as fromTableColumns from '../shared/store/table-columns-store/table-columns.reducer';
import * as fromCustomLanguages from './custom-languages-store/custom-languages.reducer';
import * as fromChannels from './channels-store/channels.reducer';
import * as fromTenderSnapshots from './tender-snapshots-store/tender-snapshots.reducer';
import * as fromCrossTabOrderSync from './cross-tab-order-sync-store/cross-tab-order-sync.reducer';
import { listingRequestReducer } from '../shared/store/listing-request-store/listing-request.reducer';
import { ListingRequestState } from '../shared/store/listing-request-store/listing-request.model';

import * as AuthActions from '../auth/store/auth.actions';

export interface AppState {
  auth: fromAuth.State;
  customLanguages: fromCustomLanguages.CustomLanguageState;
  channels: fromChannels.State;
  tableColumns: fromTableColumns.State;
  tenderSnapshots: fromTenderSnapshots.State;
  crossTabOrderSync: fromCrossTabOrderSync.State;
  /**
   * Each listing's request state for this session — page, page size, filters and the column sort,
   * keyed by listing (listing-request.model.ts). Never persisted.
   */
  listingRequest: ListingRequestState;
}

export const appReducer: ActionReducerMap<AppState> = {
  auth: fromAuth.authReducer,
  tableColumns: fromTableColumns.tableColumnsReducer,
  customLanguages: fromCustomLanguages.customLanguageReducer,
  channels: fromChannels.channelsReducer,
  tenderSnapshots: fromTenderSnapshots.tenderSnapshotsReducer,
  crossTabOrderSync: fromCrossTabOrderSync.crossTabOrderSyncReducer,
  listingRequest: listingRequestReducer
};

export function resetAppStateOnLogout(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state, action) => {
    if (action.type === AuthActions.logout.type) {
      // Everything goes, column layouts included (NBO-2516): they are the signed-in user's, kept on
      // their account and in their per-user cache, and the next person to sign in must not inherit
      // them. PreferencesService hydrates the next user's layouts.
      return reducer(undefined, action);
    }
    return reducer(state, action);
  };
}
